import Rows from '@/classes/templates/Rows'
import configurations from '@/configurations/templates'
import { flattenDeep as _flattenDeep } from 'lodash'
import Columns from '@/classes/templates/Columns'
import Blocks from '@/classes/templates/Blocks'

export default class Configuration {
  constructor ({ name = null, rows } = {}) {
    this.name = name
    this.rows = new Rows(rows)
  }

  get reference () {
    return configurations.find(({ name }) => name === this.name)
  }

  get path () {
    return this.reference?.path
  }

  get columns () {
    return new Columns(_flattenDeep(this.rows.map(row => row.columns)))
  }

  get blocks () {
    return new Blocks(_flattenDeep(this.columns.map(column => column.blocks.all)))
  }
}